module.exports = __webpack_public_path__ + "static/media/prepaid.3c1e06cf.png";